import { render, staticRenderFns } from "./ExercisesFamiliesForm.vue?vue&type=template&id=1d70bf32&scoped=true&"
import script from "./ExercisesFamiliesForm.vue?vue&type=script&lang=js&"
export * from "./ExercisesFamiliesForm.vue?vue&type=script&lang=js&"
import style0 from "./ExercisesFamiliesForm.vue?vue&type=style&index=0&id=1d70bf32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70bf32",
  null
  
)

export default component.exports